import { selectAlternative } from '../actions/alternativeActions';
import { selectAssistance } from '../actions/assistanceActions';
import { selectExperience } from '../actions/experienceActions';
import { selectFinancial } from '../actions/financialActions';
import { selectInnovation } from '../actions/innovationActions';
import { selectRegulation } from '../actions/regulationActions';
import { selectTechnology } from '../actions/technologyActions';
import { selectVision } from '../actions/visionActions';
import { buildFichaNavState, FLOW_ORIGIN_NAV } from './moduleFichaNavHelper';

const MODULE_FICHA = {
  technology: { select: selectTechnology, path: '/specialist-technology/edit-technology' },
  alternative: { select: selectAlternative, path: '/specialist-alternative/edit-alternative' },
  experience: { select: selectExperience, path: '/specialist-experience/edit-experience' },
  innovation: { select: selectInnovation, path: '/specialist-innovation/edit-innovation' },
  assistance: { select: selectAssistance, path: '/specialist-assistance/edit-assistance' },
  financial: { select: selectFinancial, path: '/specialist-financial/edit-financial' },
  vision: { select: selectVision, path: '/specialist-vision/edit-vision' },
  regulation: { select: selectRegulation, path: '/specialist-regulation/edit-regulation' }
};

export const openFlowModuleFicha = (process, record, dispatch, navigate, returnContext = {}) => {
  const entry = MODULE_FICHA[String(process || '').toLowerCase()];
  if (!entry || !record) {
    return false;
  }
  const origin = FLOW_ORIGIN_NAV[returnContext.origin] || {};
  const navState = buildFichaNavState(process, {
    returnTo: returnContext.returnTo || origin.returnTo || '/specialist-flow-cmi',
    returnLabelKey: returnContext.returnLabelKey || origin.returnLabelKey || 'flow.cmi.title',
    returnLabel: returnContext.returnLabel || origin.returnLabel
  });
  dispatch(entry.select(record));
  navigate(entry.path, { state: navState });
  return true;
};
